/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from '../Utility/CCEnum';
import { ReferenceGroup } from '../Utility/Component/ComponentReference/ReferenceGroup';
import StateComponent from './StateComponent';
import { StateID } from './StateID';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Info class for mapping [[StateComponent]] to handlers. */
@cc._decorator.ccclass("StateDispatcherData")
export default class StateDispatcherData
{
    /** [[StateID]] of [[StateComponent]] to dispatch on. */
    @property({ type: ccEnum.StateID, visible: true })
    public StateID: StateID = StateID.Initializing;

    /** [[StateID]] of [[StateComponent]] to dispatch on. */
    @property()
    public CustomStateID: string = '';

    /** [[ReferenceGroup]] of [[StateComponent]] to dispatch on. */
    @property({ type: ccEnum.ReferenceGroup, visible: true })
    public ReferenceGroup: ReferenceGroup = ReferenceGroup.MainGame;

    /** Accessor for getting the unique [[StateID]] string. */
    public get InstanceID(): string { return StateComponent.GetStateID(this.StateID, this.CustomStateID); }

    /** Array of events tied to emit on [[StateComponent]]. */
    @property(
    {
        type: cc.Component.EventHandler,
        tooltip: "i18n:COMPONENT.button.click_events"
    })
    public EventHandlers: cc.Component.EventHandler[] = [];
}
